import React, { useEffect, useState } from "react";
import { message, Select, SelectProps } from "antd";
import strings from "../../utils/Localization";
import useApi from "../../hooks/useApi";

const { Option } = Select;

interface IProps extends SelectProps<any> {
  showDovizKod: boolean;
  requestBody: {};
  onSelectedBankaHesap: (selectedBankHesap: any) => void;
}

const BankaHesapSelectOption: React.FC<IProps> = ({
  showDovizKod = false,
  requestBody = {},
  onSelectedBankaHesap = () => {},
  placeholder,
  ...rest
}) => {
  const [fetchLoading, setFetchLoading] = useState(false);
  const [bankaHesapData, setBankaHesapData] = useState([]);
  const api = useApi();

  useEffect(() => {
    fetchBankaHesap();
  }, [requestBody]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchBankaHesap = async () => {
    try {
      setFetchLoading(true);
      const response = await api.post("/bankahesap/get", {
        SortOptions: {
          ColumnName: "Id",
          SortType: "Asc",
        },
        SelectColumns: [
          {
            TableName: "",
            ColumnNames: [
              "id",
              "bankaId",
              "ad",
              "subeAd",
              "subeNo",
              "hesapNo",
              "ibanNo",
            ],
          },
          {
            TableName: "doviz",
            ColumnNames: ["id", "ad", "kod", "simge"],
          },
        ],
        ...requestBody,
      });
      if (response.status === 200) {
        setBankaHesapData(response.data.data);
      }
    } catch (error: any) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };

  return (
    <Select
      {...rest}
      placeholder={placeholder || strings?.bankaHesapSelectOption?.placeHolder}
      loading={fetchLoading}
      onSelect={(e) =>
        onSelectedBankaHesap(
          bankaHesapData.find((x: any) => x.id === parseInt(e))
        )
      }
      onClear={() => onSelectedBankaHesap({})}
    >
      {bankaHesapData.map((item: any, index) => (
        <Option key={index} value={String(item.id)}>
          {`${item.ad} ${showDovizKod ? "(" + item.doviz.kod + ")" : ""}`}
        </Option>
      ))}
    </Select>
  );
};

export default BankaHesapSelectOption;
